// third-party
import { FormattedMessage } from 'react-intl';

// assets
import { IconArticle } from '@tabler/icons';

const icons = {
    IconArticle
};

// ==============================|| MENU ITEMS - TAX ApPPROVALS ||============================== //

const taxApprovals = {
    id: 'tax-approvals',
    title: <FormattedMessage id="tax-approvals" />,
    icon: icons.IconArticle,
    type: 'group',
    url: 'tax-approvals',
    roles: ['employer']
};

export default taxApprovals;
